

import LineroBg from '../images/LaFlorDominicana/Ligero/LigeroBg.jpg'
import Linero from '../images/LaFlorDominicana/Ligero/Linero.png'

import LFD_1994 from '../images/LaFlorDominicana/1994/LFD_1994BG.png'

import LF from '../images/LaFlorDominicana/1994/LF.png'

import Oro from '../images/LaFlorDominicana/Oro/Oro.png'
import OroBG from '../images/LaFlorDominicana/Oro/OroBG.jpg'

import Litto from '../images/LaFlorDominicana/Litto/Litto.png'
import LittoBG from '../images/LaFlorDominicana/Litto/LIttoBG.jpg'

import Camerron from '../images/LaFlorDominicana/Cameroon/Camerron.png'
import CamerronBG from '../images/LaFlorDominicana/Cameroon/CamerronBG.png'


import maduro from '../images/LaGarela/Maduro/maduro.png';
import maduroBg from '../images/LaGarela/Maduro/maduroBg.jpg'


// Linero
import Linero1 from '../images/LaFlorDominicana/Ligero/Linero1.png'
import Linero1Open from '../images/LaFlorDominicana/Ligero/Linero1Open.jpg'
import Linero1Closed from '../images/LaFlorDominicana/Ligero/Linero1Close.jpg'

import Linero2 from '../images/LaFlorDominicana/Ligero/Linero2.png'
import Linero2Open from '../images/LaFlorDominicana/Ligero/Linero2Open.png'
import Linero2Closed from '../images/LaFlorDominicana/Ligero/Linero2Closed.jpg'

import Linero3 from '../images/LaFlorDominicana/Ligero/Linero3.png'
import Linero3Open from '../images/LaFlorDominicana/Ligero/Linero3Open.png'
import Linero3Closed from '../images/LaFlorDominicana/Ligero/Linero3Closed.png'

import Linero4 from '../images/LaFlorDominicana/Ligero/Linero4.png'
import Linero4Open from '../images/LaFlorDominicana/Ligero/Linero4Open.png'

import Linero5 from '../images/LaFlorDominicana/Ligero/Linero5.png'
import Linero5Open from '../images/LaFlorDominicana/Ligero/Linero5Open.jpg'
import Linero5Closed from '../images/LaFlorDominicana/Ligero/Linero5Closed.jpg'

import Linero6 from '../images/LaFlorDominicana/Ligero/Linero6.png'
import Linero6Open from '../images/LaFlorDominicana/Ligero/Linero6Open.jpg'
import Linero6Closed from '../images/LaFlorDominicana/Ligero/Linero6Closed.jpg'


//1994
import LF1 from '../images/LaFlorDominicana/1994/LF-1.png'
import LF1Open from '../images/LaFlorDominicana/1994/LF-1Open.png'
import LF1Closed from '../images/LaFlorDominicana/1994/LF-1Closed.jpg'

import LF2 from '../images/LaFlorDominicana/1994/LF-2.png'
import LF2Open from '../images/LaFlorDominicana/1994/LF-2Open.jpg'
import LF2Closed from '../images/LaFlorDominicana/1994/LF-2Closed.jpg'

import LF3 from '../images/LaFlorDominicana/1994/LF-3.png'
import LF3Open from '../images/LaFlorDominicana/1994/LF-3Open.png'
import LF3Closed from '../images/LaFlorDominicana/1994/LF-3Closed.jpg'

//Oro
import Oro1 from '../images/LaFlorDominicana/Oro/Oro-1.png'
import Oro1Open from '../images/LaFlorDominicana/Oro/Oro-1Open.jpg'
import Oro1Closed from '../images/LaFlorDominicana/Oro/Oro-1Closed.jpg'

import Oro2 from '../images/LaFlorDominicana/Oro/Oro-2.png'
import Oro2Open from '../images/LaFlorDominicana/Oro/Oro-2Open.png'
import Oro2Closed from '../images/LaFlorDominicana/Oro/Oro-2Closed.jpg'


//Litto
import Litto1 from '../images/LaFlorDominicana/Litto/Litto-1.png'
import Litto1Open from '../images/LaFlorDominicana/Litto/Litto-1Open.jpg'
import Litto1Closed from '../images/LaFlorDominicana/Litto/Litto-1Closed.jpg'

import Litto2 from '../images/LaFlorDominicana/Litto/Litto-2.png'

import Litto3 from '../images/LaFlorDominicana/Litto/Litto-3.png'

import Litto4 from '../images/LaFlorDominicana/Litto/Litto-4.png'

import Litto5 from '../images/LaFlorDominicana/Litto/Litto-5.png'


// Camerron
import Camerron1 from '../images/LaFlorDominicana/Cameroon/Cammeron1.png'
import Camerron1Open from '../images/LaFlorDominicana/Cameroon/Camerron-1Open.jpg'
import Camerron1Closed from '../images/LaFlorDominicana/Cameroon/Camerron-1Closed.jpg'

import Camerron2 from '../images/LaFlorDominicana/Cameroon/Camerron-2.png'

import Camerron3 from '../images/LaFlorDominicana/Cameroon/Camerron-3.png'

import Camerron4 from '../images/LaFlorDominicana/Cameroon/Camerron-4.png'

import Camerron5 from '../images/LaFlorDominicana/Cameroon/Camerron-5.png'



export const LaFlorDominicanaData = [
    {
        id: 1,
        title: 'La Flor Dominicana Ligero',
        subTitle: 'Донесена от уважавания ветеран от индустрията Jochy Blanco, La Galera 1936 е средно до пълна кутия пресована доминиканска пура с впечатляваща тъмнокафява еквадорска обвивка Habano, обграждаща доминиканско свързващо вещество Criollo и доминикански пълнители Piloto Cubano и Criollo.',
        paragraphOne: `Съдържайки земни нотки на кожа, кафе и черен пипер, тази сложна смес не е нищо друго освен необикновена. „La Galera“ означава „подвижната стая“ на испански.`,
        imgUrl: Linero,
        imagBg: LineroBg,

        cigars: [
            {
                id: 1,
                title: 'La Flor Dominicana Double Ligero Chisel',
                subtitle: '6"',
                img: Linero1,
                openBox: Linero1Open,
                closedBox: Linero1Closed,
            },
            {
                id: 2,
                title: 'La Flor Dominicana Double Ligero DL-600',
                subtitle: '5 1/4"',
                img: Linero2,
                openBox: Linero2Open,
                closedBox: Linero2Closed,
            },
            {
                id: 3,
                title: 'La Flor Dominicana Double Ligero Chiselito',
                subtitle: '6"',
                img: Linero3,
                openBox: Linero3Open,
                closedBox: Linero3Closed,
            },
            {
                id: 4,
                title: 'La Flor Dominicana Ligero Oscuro Natural Cabinet L-400',
                subtitle: '5 3/4"',
                img: Linero4,
                openBox: Linero4Open,
                closedBox: Linero3Closed,
            },
            {
                id: 5,
                title: 'La Flor Dominicana Double Ligero Lancero',
                subtitle: '7 1/2"',
                img: Linero5,
                openBox: Linero5Open,
                closedBox: Linero5Closed,
            },
            {
                id: 6,
                title: 'La Flor Dominicana Ligero Oscuro Natural Cabinet L-200',
                subtitle: '4 7/8"',
                img: Linero6,
                openBox: Linero6Open,
                closedBox: Linero6Closed,
            },


        ]
    },
    {
        id: 2,
        title: 'La Flor Dominicana 1994',
        subTitle: `
        La Galera Anemoi е ръчно изработена в фабриката Tabacalera Palma на Jose “Jochy” Blanco в Доминиканската република. Анемоите получават името си от гръцката дума за вятърни богове.`,
        paragraphOne: `
           Това е пурка със средно до пълно тяло, която се отличава с червеникава, мазна обвивка на САЩ от Кънектикът Broadleaf, покрита със свързващо вещество Corojo от Доминиканската република и пълнител, направен от Доминиканската република, Dominican Piloto 98 и Criollo 98 тютюни. La Galera Anemoi има вкусов профил, който се състои от кожа, кафе и ядки.        `,

        imgUrl: LF,
        imagBg: LFD_1994,
        cigars: [
            {
                id: 1,
                title: 'La Flor Dominicana 1994 Mambo ',
                subtitle: '7"',
                img: LF1,
                openBox: LF1Open,
                closedBox: LF1Closed,
            },
            {
                id: 2,
                title: 'La Flor Dominicana Andalusian Bull',
                subtitle: '6 1/2"',
                img: LF2,
                openBox: LF2Open,
                closedBox: LF2Closed,
            },
            {
                id: 3,
                title: 'La Flor Dominicana 1994 Conga',
                subtitle: '5" ',
                img: LF3,
                openBox: LF3Open,
                closedBox: LF3Closed,
            },
            {
                id: 4,
                title: 'La Flor Dominicana 1994 Aldaba',
                subtitle: '6 1/2"',
                img: LF1,
                openBox: LF1Open,
                closedBox: LF1Closed,
            },
            {
                id: 5,
                title: 'La Flor Dominicana 1994 Tango',
                subtitle: '4 1/2"',
                img: LF1,
                openBox: LF1Open,
                closedBox: LF1Closed,
            }
        ]

    },
    {
        id: 3,
        title: 'La Flor Dominicana Oro',
        subTitle: 'Представена ви от уважавания ветеран от индустрията Jochy Blanco, La Galera Connecticut е мека до средно тяло доминиканска пура с разкошна златистокафява еквадорска обвивка от Connecticut Shade, съчетана с първокласно доминиканско свързващо вещество и пълнител.',
        paragraphOne: `Съдържащ нотки на бадем, еспресо, пръст и сметана, тази гладка смес създава перфектна ежедневна пура, за ВСЯКО време от деня. „La Galera“ означава „подвижната стая“ на испански.`,
        imgUrl: Oro,
        imagBg: OroBG,
        cigars: [
            {
                id: 1,
                title: 'La Flor Dominicana Oro Maduro Oro Tubo Maduro No. 6',
                subtitle: '6"',
                img: Oro1,
                openBox: Oro1Open,
                closedBox: Oro1Closed
            },
            {
                id: 2,
                title: 'La Flor Dominicana Oro Chisel',
                subtitle: '6 1/4"',
                img: Oro2,
                openBox: Oro2Open,
                closedBox: Oro2Closed,
            },

        ]
    },
    {
        id: 4,
        title: 'Litto Gomez Diez',
        subTitle: 'Донесена от уважавания ветеран от индустрията Jochy Blanco, La Galera Habano е средно тяло доминиканска пура с красива медна еквадорска обвивка Habano на върха на доминиканско свързващо вещество Corojo и пищен микс от доминикански Piloto Cubano, Criollo 98 и Pelo de Oro пълнители.',
        paragraphOne: `
        Съдържайки кремообразни нотки на кедър, кафе и карамел, тази богата смес ще продължи да се развива и впечатлява до последното вдишване. „La Galera“ означава „подвижната стая“ на испански.
        `,
        imgUrl: Litto,
        imagBg: LittoBG,
        cigars: [
            {
                id: 1,
                title: 'Litto Gomez Diez Dominicano',
                subtitle: '6 7/8"',
                img: Litto1,
                openBox: Litto1Open,
                closedBox: Litto1Closed,
            },
            {
                id: 2,
                title: 'Litto Gomez Diez Chisel Puro',
                subtitle: '5 1/2"',
                img: Litto2,
                openBox: Litto1Open,
                closedBox: Litto1Closed,
            },
            {
                id: 3,
                title: 'Litto Gomez Diez Lancero',
                subtitle: '4 7/8"',
                img: Litto3,
                openBox: Litto1Open,
                closedBox: Litto1Closed,
            },
            {
                id: 4,
                title: 'Litto Gomez Diez Small Batch No. 6',
                subtitle: '6 3/4"',
                img: Litto4,
                openBox: Litto1Open,
                closedBox: Litto1Closed,
            },
            {
                id: 5,
                title: 'Litto Gomez Diez Oriental',
                subtitle: '4 7/8"',
                img: Litto5,
                openBox: Litto1Open,
                closedBox: Litto1Closed,
            },

        ]
    },
    {
        id: 5,
        title: 'La Flor Dominicana Cameroon',
        subTitle: `Представен ви от уважавания ветеран от индустрията Jochy Blanco, La Galera Maduro е доминиканско пълноценно лакомство, включващо шоколадово кафяво мексиканско обвиване на San Andres, заедно с доминиканско свързващо вещество и пълнителна комбинация от доминикански Criollo '98 и Dominican Piloto Cubano`,
        paragraphOne: `
        Съдържащ силни нотки на какао, земя и кедър, тази грандиозна смес ще ви остави влюбени в своята смела сладост и гладко, богато покритие „La Galera“ означава „подвижната стая“ на испански.        `,
        imgUrl: Camerron,
        imagBg: CamerronBG,
        cigars: [
            {
                id: 1,
                title: 'La Flor Dominicana Cameroon Cabinet No. 1',
                subtitle: '6 1/2"',
                img: Camerron1,
                openBox: Camerron1Open,
                closedBox: Camerron1Closed,
            },
            {
                id: 2,
                title: 'La Flor Dominicana Cameroon Cabinet Torpedo',
                subtitle: '6 1/4"',
                img: Camerron2,
                openBox: Camerron1Open,
                closedBox: Camerron1Closed,
            },
            {
                id: 3,
                title: 'La Flor Dominicana Cameroon Cabinet Lancero',
                subtitle: '7 1/2"',
                img: Camerron3,
                openBox: Camerron1Open,
                closedBox: Camerron1Closed,
            },
            {
                id: 4,
                title: 'La Flor Dominicana Cameroon Cabinet No. 1',
                subtitle: '6 1/2"',
                img: Camerron4,
                openBox: Camerron1Open,
                closedBox: Camerron1Closed,
            },
            {
                id: 5,
                title: 'La Flor Dominicana Cameroon Cabinet Chisel',
                subtitle: '6"',
                img: Camerron5,
                openBox: Camerron1Open,
                closedBox: Camerron1Closed,
            },

        ]
    },
]